import {PriceTierWithHasProductsFlag} from '@treez/commons/sharedTypings/priceTier';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {ParsedQs} from 'qs';

export enum Direction {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}

export type ColumnWidthOption = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type JustifyContentOption =
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | undefined;

export interface SearchQueryParameters {
    page?: number;
    pageSize?: number;
    searchTerm?: string;
    sortCategory?: string;
    sortOrder?: SortDirection;
}

export interface ProductParameters {
    brand?: string[];
    classification?: string[];
    effect?: string[];
    flavor?: string[];
    generalAttribute?: string[];
    ingredient?: string[];
    internalTag?: string[];
    subtype?: string[];
    type?: string[];
}

export interface ProductFilters {
    brands?: string[];
    classifications?: string[];
    effects?: string[];
    flavors?: string[];
    generalAttributes?: string[];
    ingredients?: string[];
    internalTags?: string[];
    subtypes?: string[];
    statuses?: string[];
    types?: string[];
}

export type AdvancedProductFilters = Omit<ProductFilters, 'statuses' | 'types'>;

export enum SortDirection {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export interface PriceTierWithCatalogPresence extends PriceTierWithHasProductsFlag {
    catalogPresence: string[];
}

export interface HighlightedAndRegularProducts {
    highlightedProducts: ProductInCatalog[];
    otherProducts: ProductInCatalog[];
}

export interface PriceManagementSearchParams extends ParsedQs {
    label?: string;
    isActive?: string;
    method?: string;
}
